export { isOnline, getConnectivityStatus, subscribeConnectivity } from './connectivityInfra';
export type { ConnectivityStatus } from './connectivityInfra';
